import store from "../../store";
import ValueMapper from "../common/value-mapper";
import ApiError from "./api-error";
import Account from "@/logic/api/account.js";
import Api from "@/logic/api/api.js";

/**
 * APIと接続するバックエンド
 */
class ApiBackend {
  /**
   * APIの定義を取得する
   * @param {URLのパス} key
   * @returns API定義
   */
  target(key) {
    return ValueMapper.map(
      // post以外のメソッドを利用するAPIはここに書く
      {}
    ).getOrElse(key, {
      path: key,
      method: "post",
      mode: process.env.VUE_APP_FETCH_REQUEST_MODE,
    });
  }

  /**
   * クッキーを取得する
   * @param {クッキー名} name
   * @returns クッキー情報
   */
  getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  /**
   * APIを実行する
   * @param {APIの定義} api
   * @param {Bodyなどのリクエストパラメータ} parameter
   * @returns データを返却するPromiseオブジェクト
   */
  async call(api, parameter) {
    try {
      // APIにリクエストを投げる
      let url = process.env.VUE_APP_API_ROOT + api["path"];
      let payload = {
        method: api["method"],
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": this.getCookie("csrftoken"),
        },
      };
      // トークンがあればトークンを設定する
      if (store.getters.token) {
        let expiration = store.getters.tokenExpiration;
        let date = new Date();
        if (expiration > date.getTime()) {
          payload["headers"]["Authorization"] = "Bearer " + store.getters.token;
        } else {
          // トークンのリフレッシュを試みる
          if (store.getters.refreshToken) {
            let refreshUrl = process.env.VUE_APP_API_ROOT + '/refresh';
            let refreshPayload = {
              method: 'POST',
              cache: "no-cache",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": this.getCookie("csrftoken"),
              },
              body: JSON.stringify({
                'refresh_token': store.getters.refreshToken
              }),
            };

            const response = await fetch(refreshUrl, refreshPayload);
            if (response.ok) {
              let result = await response.json();
              store.commit("setToken", result.token);

              Api.call("/admin/user", {
                purpose: "VIEW_SELF",
              }).then((users) => {
                // ユーザー情報を共通ストアに反映する
                Account.applyUserInfo(store, users);
                // ログイン履歴に書き込みする
                if (users && users.users && users.users.length >= 1) {
                  Api.call("/admin/user/history/insert", {
                    user: users.users[0],
                  })
                }
              }).catch(() => {
                Account.signOut(store);
              });

              payload["headers"]["Authorization"] = "Bearer " + result.token;
            }
          }
        }
      }
      // リクエストBodyがあれば設定する
      if (parameter != null && parameter != undefined) {
        payload["body"] = JSON.stringify(parameter);
      }
      // APIからレスポンスを受け取る
      const response = await fetch(url, payload);
      if (!response.ok) {
        // レスポンスエラーがあればrejectを返す
        return Promise.reject(ApiError.fromStatus(response.status));
      } else {
        return response.json();
      }
    } catch (e) {
      console.error(e);
      return Promise.reject(ApiError.fromMessage(500, "Exception"));
    }
  }

    async callFormData(api, formData) {
    try {
      // APIにリクエストを投げる
      let url = process.env.VUE_APP_API_ROOT + api["path"];
      let payload = {
        method: api["method"],
        cache: "no-cache",
        credentials: "include",
        body: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": this.getCookie("csrftoken")
        },
      };
      // トークンがあればトークンを設定する
      if (store.getters.token) {
        payload["headers"]["Authorization"] = "Bearer " + store.getters.token;
      }
      // 明示的にContent-Typeを削除する
      delete payload.headers['Content-Type'];

      // APIからレスポンスを受け取る
      const response = await fetch(url, payload);
      if (!response.ok) {
        // レスポンスエラーがあればrejectを返す
        return Promise.reject(ApiError.fromStatus(response.status));
      } else {
        console.log(response);
        return response.body;
      }
    } catch (e) {
      console.error(e);
      return Promise.reject(ApiError.fromMessage(500, "Exception"));
    }
  }
}

export default new ApiBackend();
